// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "banner-bLTkq";
var _3 = "icon-3m_km";
var _4 = "viewOffers-1ysdT";
var _5 = "arrow-2AQfd";
export { _1 as "__esModule", _2 as "banner", _3 as "icon", _4 as "viewOffers", _5 as "arrow" }
export default { "__esModule": _1, "banner": _2, "icon": _3, "viewOffers": _4, "arrow": _5 }
